import { Box } from '@mui/material';
import { useFlowStore } from '@/state/stores/use-flow-store';
import FlowContributorList from '../edit-details/flow-contributor-list';

export default function FlowContributorsTab() {
  const flow = useFlowStore((s) => s.flow);

  if (!flow) return null;

  return (
    <Box>
      <Box>
        <FlowContributorList flow={flow} />
      </Box>
    </Box>
  );
}
